import { Button, Dialog, Heading, Text } from '@betterment/samba-react';

interface ReportFieldsDialogProps {
  name: string;
  description?: string | null;
  columns: string[];
}

export const ReportFieldsDialog = ({ reportFields }: { reportFields: ReportFieldsDialogProps }) => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Button
          aria-label={`See report fields for ${reportFields.name}`}
          variant="textPrimary"
          css={{ color: 'text', textDecoration: 'underline' }}
        >
          See report fields
        </Button>
      </Dialog.Trigger>
      <Dialog.Content
        aria-label={`Fields for ${reportFields.name}`}
        css={{ maxHeight: '85vh', width: 'container.large', p: 'space.400', gap: 'space.400', overflowX: 'scroll' }}
      >
        <Dialog.Title>
          <Heading as="h2" variant="title300" data-testid={`${reportFields.name} title`}>
            {reportFields.name}
          </Heading>
        </Dialog.Title>
        <Dialog.Description>
          {reportFields.description && (
            <Text data-testid={`${reportFields.name} description`}>{reportFields.description}</Text>
          )}
          <ul>
            {reportFields.columns.map(field => (
              <li key={field}>
                <Text>{field}</Text>
              </li>
            ))}
          </ul>
        </Dialog.Description>
      </Dialog.Content>
    </Dialog>
  );
};
